module.exports = __webpack_public_path__ + "img/home_map_India_blue.8b17d7b4.png";